<template>
  <div class="flex" style="font-size: .9rem;">
    <div v-for="(tab, idx) in tabs" :key="`tab-${idx}`">
      <div class="tab1-shape unselect" :style="[tabStyle(tab)]" :class="{'selected-tab1':selectedTab===tab.value}" @click="clickTab(tab.value)">{{ tab.label }}</div>
    </div>
    <!--<div class="lp-tab" :class="{'lp-tab-selected':selectedTab===0}" @click="clickTab(0)">상품 정보 제공 고시</div>
    <div class="lp-tab" :class="{'lp-tab-selected':selectedTab===1}" @click="selectedTab=1">배송안내</div>
    <div class="lp-tab" :class="{'lp-tab-selected':selectedTab===2}" @click="selectedTab=2">교환 및 반품안내</div>-->
  </div>
</template>

<script>
  export default {
    name: "tab1",
    props: {
      tabs: {
        type: Array,
        required: true
      },
      backgroundColor: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        tabArr: this.tabs,
        selectedTab: 0
      }
    },
    created () {

    },
    methods: {
      tabStyle(tab) {
        let style = {}
        if(this.selectedTab===tab.value) {
          style.backgroundColor = 'white'
        }
        return style
      },
      clickTab (value) {
        this.selectedTab = value;
        this.$emit('selectedValue', value);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .tab1-shape
    display flex
    padding 10px 24px
    color #555
  .selected-tab1
    border 1px solid #ccc
    border-bottom 0
    color #555
    border-top-left-radius 3px
    border-top-right-radius 3px


</style>
